<template>
  <div class="zujianBox">
    <div class="boxA" >
        <div class="boxAcont">
            <div class="itemA">
              <p class="name color1">{{totalData.historyComeNum}}</p>
              <p class="name1">历史入库量总计(吨)</p>
            </div>
             <div class="itemA">
              <p class="name color1">{{totalData.historyOutNum}}</p>
              <p class="name1">历史出库量总计(吨)</p>
            </div>
        </div>
      </div>
      <div class="zjBottom">
        <el-row :gutter="12">
          <el-col :span="12">
            <div class="boxA">
            <div class="left_h">
              <span class="span_one">当日出入库量对比(吨)</span>
            </div>
            <div class="boxAcont"  id="zhe1">

            </div>
          </div>
          </el-col>
          <el-col :span="12">
            <div class="boxA">
            <div class="left_h">
              <span class="span_one">历史出入库量对比(吨)</span>
            </div>
            <div class="boxAcont" id="zhe2">

            </div>
          </div>
          </el-col>
        </el-row>

      </div>
  </div>
</template>
<script>
import { warehouseTotal } from '@/api/data-center-server'
export default {
  data () {
    return {
      totalData: {}
    }
  },
  created () {

  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      warehouseTotal({}).then(res => {
        this.totalData = res
        // 柱状图数据
        var inData1 = []
        var outData1 = []
        var inData2 = []
        var outData2 = []
        var nameData = []
        console.log(res.list)
        res.list.forEach((item, index) => {
          nameData.push(item.tenantName)
          inData1.push(item.dateComeNum)
          outData1.push(item.dateOutNum)
          inData2.push(item.historyComeNum)
          outData2.push(item.historyOutNum)
        })
        this.zhuChart(inData1, outData1, nameData, 'zhe1')
        this.zhuChart(inData2, outData2, nameData, 'zhe2')
      })
    },
    zhuChart (valueUpData, valueDownData, nameData, id) {
      let myChart = this.$echarts.init(document.getElementById(id))
      // 绘制图表--柱状
      myChart.setOption({
        color: ['#0DD9FE', '#52F23A'],
        // backgroundColor: "#323a5e",
        grid: {
          left: '2%',
          right: '4%',
          bottom: '9%',
          top: '25%',
          containLabel: true
        },
        legend: {
          icon: 'circle',
          data: ['入库量', '出库量'],
          textStyle: {
            color: '#fff'
          }
        },
        // ---  提示框 ----
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: 'item', // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: 'shadow',
            axis: 'auto'
          },
          formatter: function (value) {
            return value.marker + value.seriesName + '：' + value.value
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: {
          type: 'category',
          data: nameData,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 60,
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            },
            formatter: function (data) {
              let valueTxt = ''
              if (data.length > 5) {
                valueTxt = data.substring(0, 6) + '...' // 想要展示的x轴名称长度
              } else {
                valueTxt = data
              }
              return valueTxt
            }
          }
        },
        yAxis: {
          type: 'value',
          data: ['2000', '4000', '6000', '8000'],
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        series: [
          {
            name: '入库量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: valueUpData
          },
          {
            name: '出库量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: valueDownData
          }
        ]
      })
    },
    zheChart (inData, outData, nameData, id) {
      let _this = this
      let idChart = _this.$echarts.init(document.getElementById(id))
      // 绘制图表--折线图
      var idChartOption = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['入库量', '出库量'],
          color: ['#fff'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '6%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: nameData,
          // 横坐标轴颜色
          axisLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 60,
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            },
            formatter: function (data) {
              let valueTxt = ''
              if (data.length > 5) {
                valueTxt = data.substring(0, 6) + '...' // 想要展示的x轴名称长度
              } else {
                valueTxt = data
              }
              return valueTxt
            }
          }
        },
        yAxis: {
          type: 'value',
          max: '50000',
          // 横坐标轴颜色
          axisLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          }
        },
        series: [
          {
            name: '入库量',
            type: 'line',
            color: '#E09C13',
            data: inData
          },
          {
            name: '出库量',
            type: 'line',
            color: '#3BE232',
            data: outData
          }
        ]
      }
      idChart.setOption(idChartOption)
    }
  },
  computed: {

  },
  filters: {

  },
  destroyed () {
    clearInterval(this.nowTimer)
    clearInterval(this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.zujianBox{
  height: 100%;
  width: 100%;
  display: flex;
 flex-direction: column;
  .boxAcont{
    padding: 12px 0;
  }
}
.zjBottom{
  flex: 1;
  margin-top: 12px;
  .boxA{
    height: 100%;
  }
}
/deep/.el-row{
  height: 100%;
  display: flex;
  .el-col{
  height: 100%;
  }
}
.boxA{
    width: 100%;
    border: 1px solid #045f59;
    box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75) inset;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .boxAcont{
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex: 1;
      text-align: center;
      .name{
        font-size: 24px;
        margin-bottom: 10px;
      }
      .name1{
        color: #ffffff;
        font-size: 12px;
      }
      p{
        margin: 0;
      }
    }
}
.left_h {
  height: 40px;
  line-height: 40px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: rgba(41, 139, 208, 0.3);
  box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75);
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.color1{
    color: #03faec;
}
.color2{
    color: #ffa500;
}
.color3{
    color: #4df442;
}
.color4{
    color: #2e9cfd;
}
.color5{
    color: #fffc0d;
}
</style>
